module.exports = __webpack_public_path__ + "img/fst4fa53ebf.9607e040.png";